import { definitions } from './definitions/definitions';
import { getAllAnimationProperties } from './utils/definitionsUtils';
import * as mediaResizeMap from './definitions/mediaResizeMap';

export { TweenEngine } from './classes/TweenEngine';
export { AnimationsKit } from './classes/AnimationsKit';
export { TweenEngineGreenSock } from './classes/TweenEngineGreenSock3';
export { Sequence } from './classes/Sequence';
export { mediaResizeMap };
export const animationProperties = getAllAnimationProperties(definitions);

export * from './types';
